import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import { toolInput } from "../tool-input";
import type { ToolActivityState } from "../tool-activity-state";

export function describeInteractiveView(verb: {
  running: string;
  done: string;
  failed: string;
}): (
  record: Record<string, unknown>,
  state: ToolActivityState,
) => ToolActivity {
  return (
    record: Record<string, unknown>,
    state: ToolActivityState,
  ): ToolActivity => {
    const title = toolInput.trimmed(record.title);
    const subject = title ? `"${title}"` : "an interactive view";
    if (state.hasFailed) return labelOnly(`${verb.failed} ${subject}`);
    return labelOnly(
      `${state.isRunning ? verb.running : verb.done} ${subject}`,
    );
  };
}
